<!-- Navbar -->
<app-asahi-navbar></app-asahi-navbar>

<!--success content-->
<div id="success"
  class="flex flex-col items-center gap-80 self-stretch relative"
  (click)="closeBottomSheet($event)">
  
  <div class="flex flex-col items-center gap-20 w-full pt-[30px] pb-[80px]">
    <!-- Content -->
    <div class="flex flex-col items-center gap-[10px] w-full sm:w-[510px] h-auto sm:h-[453px] max-w-[800px] px-4">
      <img src="/png/Clip path group.svg" alt="Submitted Successfully"
        class="w-[110px] h-[110px] sm:w-[200px] sm:h-[200px]" />
      <h3 class="self-stretch text-center text-[#F5375C] font-[manrope]
        text-[20px] sm:text-[28px] not-italic font-extrabold leading-normal tracking-[-0.56px]">
        {{ 'Submitted Successfully!' | translate }}
      </h3>

      <p class="w-[90%] sm:w-full mx-auto text-center text-[#1B1B1B] font-[manrope]
        text-[12px] sm:text-[16px] not-italic font-normal leading-normal">
        {{ 'Thank you for your interest in our product! Your registration details have been saved.
        Specialists will contact you shortly to provide consultation.' | translate }}
      </p>
    </div>

    <!-- Laptop Screen -->
    <img src="/png/Frame 1597882382.svg"
      class="hidden sm:block w-[292px] h-[292px] bg-cover bg-no-repeat bg-center absolute top-[360px] left-[520px] -rotate-9" />

    <div class="hidden sm:flex w-[674px] p-[60px] justify-center items-center gap-8 rounded-[24px] bg-white shadow-[0_4px_24px_0_rgba(0,0,0,0.12)]">
      <div class="w-[180px] h-[180px] p-[16.364px] rounded-[12.273px]
        bg-[#FAFAFA] shadow-[0_2.045px_16.364px_0_rgba(0,0,0,0.16)]
        flex items-center justify-center">
        <img src="/png/QR.svg" alt="image"
          class="w-full h-full object-contain py-2 border-2 border-dashed border-black rounded-[12px]" />
      </div>
      <div class="flex flex-col items-start gap-4 flex-1">
        <h3 class="self-stretch text-[#121212] text-center font-[manrope] text-[32px] not-italic font-bold leading-[140%]">
          {{ 'Scan and Download' | translate }}
        </h3>
        <p class="self-stretch text-[#1B1B1B] text-center font-[manrope] text-[18px] not-italic font-normal leading-[140%]">
          {{ 'Get our app in seconds, Just scan the QR code to sign in' | translate }}
        </p>
      </div>
    </div>

    <!-- Bottom Sheet Popup (Mobile only) -->
    <div
      *ngIf="showBottomSheet"
      class="fixed bottom-0 inset-x-0 sm:hidden transition-all duration-300"
      (click)="$event.stopPropagation()">
      <!-- Outer layer -->
      <div class="w-full bg-white rounded-t-[30px] shadow-[0_8px_32px_0_rgba(0,0,0,0.25)]">
        <div class="p-6 text-center relative">
          <!-- Top Handle -->
          <div class="w-12 h-1 bg-gray-400 rounded-full mx-auto mb-4"></div>

          <!-- Image -->
          <img src="/png/Frame 1597882382.svg"
            class="w-[220px] h-[220px] bg-cover bg-no-repeat bg-center mx-auto -rotate-9" />

          <!-- Title -->
          <h3 class="text-[18px] font-bold leading-[120%] text-[#030E21] text-center font-[Manrope] mb-2">
            {{ 'Download App' | translate }}
          </h3>

          <!-- Subtitle -->
          <p class="text-[14px] font-normal leading-[140%] tracking-[-0.28px]
            text-[#3A3839] text-center font-[Manrope] mb-6">
            {{ 'Get started in seconds. Tap below to install and sign in' | translate }}
          </p>

          <!-- Button -->
          <div class="flex justify-center">
            <a href="https://livwell.app.link/90iNAlNL2Jb?_p=c11130dc9d037af3e30387fc"
              target="_blank" rel="noopener noreferrer"
              class="flex items-center justify-center gap-2 px-10 py-3
              rounded-full bg-[#2AD189] text-black font-[Manrope]
              text-[16px] font-bold leading-[120%] shadow-lg hover:bg-[#24b777] transition">
              {{ 'Download App' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--footer-->
<div class="hidden sm:block">
  <app-asahi-footer></app-asahi-footer>
</div>
